/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default [
  {
    header : "DASHBOARD",
    icon : "thumb_up_alt",
    items:[
      // {
      //   url: "/dashboard",
      //   name: "Painel de Controle",
      //   slug: "home",
      //   icon: "HomeIcon",
      //   role: 1
      // },
      {
        name: "Pedidos",
        slug: "home",
        icon: "shopping_basket",
        role: 3,
        submenu: [
          {
            url: "/bills/opened",
            name: "Na mesa",
            slug: "openedBills",
            role: 3
          },
          {
            url: "/bills/delivery",
            name: "Delivery / Takeout",
            slug: "deliveryBills",
            icon: "ShoppingBagIcon",
            role: 1
          },
          {
            url: "/bills/all",
            name: "Histórico",
            slug: 'allBills',
            role: 3
          }
        ]
      },
      
      // {
      //   url: "/account/copyData/",
      //   name: "Copiar Dados",
      //   slug: "Ratings",
      //   icon: "restaurant_menu",
      //   role: 0,
      // },
      // {
      //   url: "/teste/",
      //   name: "Teste",
      //   slug: "Ratings",
      //   icon: "shopping_basket",
      //   role: 0,
      // },
      {
        url: "/product/all",
        name: "Produto",
        slug: "product",
        icon: "restaurant_menu",
        role: 1,
        submenu : [
          {
            url: '/product/all',
            name: "Gerenciar",
            slug: "manage-products",
          },
          {
            url: '/product/add',
            name: "Adicionar",
            slug: "edit-product",
          },
          {
            url: '/product/organize',
            name: 'Organizar',
            slug: 'organize-product'
          }
        ]
      },
      {
        url: "/coupons/all",
        name: "Cupons",
        slug: "coupons",
        icon: "local_offer",
        role: 0,
      },
      {
        url: "/options/all",
        name: "Opções de Produtos",
        slug: "optionsAll",
        icon: "toggle_on",
        role: 0,
      },
      {
        url: "/table/all",
        name: "Qr Codes",
        slug: "table",
        icon: "code",
        role: 0,
      },
      {
        url: "/",
        name: "Cozinha",
        slug: "kitchen",
        icon: "room_service",
        role: 0,
        submenu : [
          {
            url: '/kitchen/settings',
            name: "Configurações",
            slug: "kitchen-settings",
            role: 0
          }
        ]
      },
      {
        url: "/",
        name: "Caixa",
        slug: "cashier",
        icon: "attach_money",
        role: 0,
        submenu : [
          {
            url: '/cashier/fiscal',
            name: "Notas Fiscais",
            slug: "cashier-fiscal",
            role: 1
          },
          {
            url: '/cashier/fiscalReport',
            name: "Relatórios de Notas Fiscais",
            slug: "cashier-fiscal",
            role: 1
          }
        ]
      },
      {
        url: "/",
        name: "Relatórios",
        slug: "report",
        icon: "bar_chart",
        role: 1,
        submenu : [
          {
            url: "/reports/ratings",
            name: "Avaliações",
            slug: "Ratings",
            icon: "stars",
            role: 0,
          },
          {
            url: '/reports/taxes',
            name: "Taxas",
            slug: "report-taxes",
            role: 2
          },
          {
            url: '/reports/closing',
            name: "Fechamento diário",
            slug: "report-closing",
            role: 1
          },
          {
            url: null,
            name: "Por Período",
            slug: "report-period",
            submenu : [
              {
                url: '/reports/period/daily',
                name: 'Diário',
                slug: "report-period-daily",
                role: 1
              }
            ]
          }
        ]
      },
    ]
  },
  {
    header: "OUTROS",
    icon: "",
    items: [
    {
      url: "/accountSettings/0",
      name: "Configurações",
      slug: "billing",
      icon: "settings",
      role: 2,
    }
  ]
  }
]
